<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Manage Staff</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <modal
        :show.sync="modals.showModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form">
              <base-input
                label="First name:"
                class="mb-3"
                name="batch"
                type="text"
                placeholder="Enter first name"
                v-model="myObj.firstName"
                v-bind:error="fnError"
              />

              <base-input
                label="Last name"
                class="mb-3"
                name="batch"
                type="text"
                placeholder="Enter last name"
                v-model="myObj.lastName"
                v-bind:error="lnError"
              />
              <base-input label="Country">
                <multiselect
                  placeholder="Select country"
                  v-model="cmbCountry.value"
                  :options="cmbCountry.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbCountry"
                >
                </multiselect>
              </base-input>

              <base-input
                label="Description"
                class="mb-3"
                name="batch"
                type="text"
                placeholder="Enter description"
                v-model="myObj.description"
              />
              <base-input
                label="Speciality"
                class="mb-3"
                name="batch"
                type="text"
                placeholder="Enter speciality"
                v-model="myObj.speciality"
              />

              <base-input label="Day off">
                <multiselect
                  placeholder="Select day off"
                  v-model="cmbdayOff.value"
                  :options="cmbdayOff.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbdayOff"
                >
                </multiselect>
              </base-input>

              <base-input label="Status">
                <multiselect
                  placeholder="Select status"
                  v-model="cmbStatus.value"
                  :options="cmbStatus.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbStatus"
                >
                </multiselect>
              </base-input>

              <label class="btn btn-success col">
                <input
                  type="file"
                  id="file"
                  ref="file"
                  @change="selectFile"
                  accept="image/*"
                />
              </label>

              <div>
                <base-button
                  @click="AddStaff()"
                  :disabled="saving"
                  type="primary"
                  class="col"
                  ><i v-bind:class="sign"></i> {{ optionName }}</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>

      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header"> </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div style="margin-bottom: 5px">
                <base-button icon type="primary" @click="AddModal()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Add new staff</span>
                </base-button>

                <base-button
                  hidden
                  icon
                  v-if="selectedRows.length"
                  type="danger"
                  @click="RemoveSelected()"
                >
                  <span class="btn-inner--icon"
                    ><i class="fas fa-trash"></i
                  ></span>
                  <span class="btn-inner--text">Remove selected</span>
                </base-button>
              </div>

              <el-select
                hidden
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary pull-right"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <!-- <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div> -->
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Options">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="editRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-edit"></i>
                  </base-button>

                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import Multiselect from "vue-multiselect";

export default {
  mixins: [clientPaginationMixin],
  components: {
    Multiselect,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  created() {
    this.LoadData();
    this.FillCmbCountry();
  },
  data() {
    return {
      myObj: {
        staffID: 0,
        firstName: "",
        lastName: "",
        country: "",
        flag: "",
        profile: "",
        rating: 0,
        speciality: "",
        description: "",
        status: "",
        dayOff: "",
      },
      selects: {
        country: [
          { value: "pakistan", value: "Pakistan" },
          { value: "india", value: "India" },
          { value: "uae", value: "UAE" },
          { value: "malaysia", value: "Malaysia" },
          { value: "indonesia", value: "Indonesia" },
          { value: "iran", value: "Iran" },
          { value: "afghanistan", value: "Afghanistan" },
          { value: "egypt", value: "Egypt" },
          { value: "phillippines", value: "Phillippines" },
        ],

        status: [
          { value: "active", value: "Active" },
          { value: "inactive", value: "Inactive" },
        ],

        flags: [
          {
            country: "Pakistan",
            flagURL:
              "http://appick.io/u/lessons/f992badd-c0ed-45ce-b56a-345b55dca545.png",
          },
          {
            country: "Afghanistan",
            flagURL:
              "http://appick.io/u/lessons/e83da18b-cb7f-45b0-92ed-6de9681d11f2.png",
          },
          {
            country: "India",
            flagURL:
              "http://appick.io/u/lessons/d9daf346-4cdf-4c0e-830d-31b8f618381d.png",
          },
          {
            country: "Iran",
            flagURL:
              "http://appick.io/u/lessons/b52e3c9a-72ef-4583-94ad-ee8509c90a90.png",
          },
          {
            country: "UAE",
            flagURL:
              "http://appick.io/u/lessons/bed9e08e-03d8-480e-a209-e886c3ba7e68.png",
          },
          {
            country: "Malaysia",
            flagURL:
              "http://appick.io/u/lessons/75febcb2-c9f9-4b54-8b9f-eb04c519a44f.png",
          },
          {
            country: "Indonesia",
            flagURL:
              "http://appick.io/u/lessons/61dcce45-717b-4dcc-b8a9-40a8eccaaa06.png",
          },
          {
            country: "Egypt",
            flagURL:
              "http://appick.io/u/lessons/d14fb3b5-153d-4e1f-969b-ea31cdbc087d.png",
          },
          {
            country: "Phillippines",
            flagURL:
              "http://appick.io/u/lessons/cf9a58db-487b-4574-af75-b4aa98e191e1.png",
          },
        ],
      },
      propsToSearch: [
        "firstName",
        "lastname",
        "country",
        "profile",
        "speciality",
      ],
      tableColumns: [
        {
          prop: "firstName",
          label: "First name",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "lastName",
          label: "Last Name",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "country",
          label: "Country",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "speciality",
          label: "Speciality",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "dayOff",
          label: "Day Off",
          minWidth: 150,
          sortable: true,
        },
      ],
      cmbCountry: {
        value: {},
        data: [],
      },
      cmbStatus: {
        value: {
          name: "Active",
          value: "active",
        },
        data: [
          {
            name: "Active",
            value: "active",
          },
          {
            name: "Inactive",
            value: "inactive",
          },
        ],
      },
      cmbdayOff: {
        value: {
          name: "Sunday",
          value: "Sun",
        },
        data: [
          {
            name: "Sunday",
            value: "Sun",
          },
          {
            name: "Monday",
            value: "Mon",
          },
          {
            name: "Tuesday",
            value: "Tue",
          },
          {
            name: "Wednesday",
            value: "Wed",
          },
          {
            name: "Thrusday",
            value: "Thu",
          },
          {
            name: "Firday",
            value: "Fri",
          },
          {
            name: "Saturday",
            value: "Sat",
          },
        ],
      },
      file: "",
      tableData: [],
      selectedRows: [],
      modals: {
        showModal: false,
      },
      optionName: "Add",
      name: "",
      prefixname: "",
      prefixError: false,
      fnError: false,
      lnError: false,
      countryError: false,
      ratingError: false,
      specError: false,
      desError: false,
      statusError: false,
      flagError: false,
      sign: "fas fa-plus",
      shouldAdd: true,
      saving: false,
      eIndex: 0,
    };
  },
  methods: {
    LoadData() {
      var url = this.$store.state.domain + "/staff";
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
          } else {
            this.tableData = response.data;
          }
        })
        .catch(function (error) {});
    },
    FillCmbCountry() {
      var url = this.$store.state.domain + "/flags";
      axios
        .get(url)
        .then((res) => {
          this.cmbCountry.value = {};
          this.cmbCountry.data = [];
          res.data.forEach((elem) => {
            this.cmbCountry.data.push({
              name: elem.country,
              value: elem.flagID,
            });
          });
        })
        .catch((err) => {
          console.error("cmbCat Fill", err);
        });
    },
    selectFile() {
      this.file = this.$refs.file.files[0];
    },
    AddStaff() {
      var regexName = /^[a-zA-Z ]{2,20}$/;
      var isValidFname = regexName.test(this.myObj.firstName);

      if (this.myObj.firstName === null || !isValidFname) {
        this.fnError = "Please enter valid first name";
      } else {
        this.fnError = false;

        if (
          this.cmbCountry.value === null ||
          this.cmbCountry.value.value === undefined
        ) {
          swal({
            title: `Select country`,
            text: "Please select the country from dropdown.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-error",
            type: "error",
          });
        } else {
          if (
            this.cmbStatus.value === null ||
            this.cmbStatus.value.value === undefined
          ) {
            swal({
              title: `Select status`,
              text: "Please select the status from dropdown.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-error",
              type: "error",
            });
          } else {
            if (
              this.cmbdayOff.value === null ||
              this.cmbdayOff.value.value === undefined
            ) {
              swal({
                title: `Select day off`,
                text: "Please select a day off from dropdown.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-error",
                type: "error",
              });
            } else {
              this.myObj.flag = this.cmbCountry.value.value;
              this.myObj.status = this.cmbStatus.value.value;
              this.myObj.dayOff = this.cmbdayOff.value.value;

              if (this.myObj.staffID === 0) {
                //Add
                this.optionName = "Adding...";
                //Upload cover
                if (this.file !== "") {
                  let formData = new FormData();
                  formData.append("file", this.file);
                  console.log(this.file);
                  axios
                    .post("https://upload.appick.io", formData, {
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                    })
                    .then((e) => {
                      console.log(e.data);
                      // this.file = undefined;
                      var fn =
                        "https://dk0pm9zdlq16s.cloudfront.net/" +
                        e.data.myresp[0].filename;
                      this.myObj.profile = fn;
                      this.AddS();
                    });
                } else {
                  this.AddS();
                }
              } else {
                //Edit
                this.optionName = "Saving...";
                console.log("myObj Edit", this.myObj);
                //Upload cover
                if (this.file !== "") {
                  let formData = new FormData();
                  formData.append("file", this.file);
                  console.log(this.file);
                  axios
                    .post("https://upload.appick.io", formData, {
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                    })
                    .then((e) => {
                      console.log(e.data);
                      // this.file = undefined;
                      var fn =
                        "https://dk0pm9zdlq16s.cloudfront.net/" +
                        e.data.myresp[0].filename;
                      this.myObj.profile = fn;
                      this.UpdateST();
                    });
                } else {
                  this.UpdateST();
                }
              }
            }
          }
        }
      }
    },
    AddS() {
      var url = this.$store.state.domain + "/staff/save";
      console.log(url, this.myObj);
      axios
        .post(url, this.myObj)
        .then((response) => {
          console.log("Res", response);
          if (response.data.status === "error") {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.myObj.staffID = response.data.insertId;
            this.LoadData();

            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> New staff is added.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        })
        .finally(() => {
          this.saving = false;
          this.fnError = "";
          this.lnError = "";
          this.countryError = "";
          this.ratingError = "";
          this.specError = "";
          this.desError = "";
          this.statusError = "";
          this.flagError = "";
          this.myObj.staffID = 0;
          this.myObj.firstName = "";
          this.myObj.lastName = "";
          this.myObj.country = "";
          this.myObj.flag = "";
          this.myObj.profile = "";
          this.myObj.rating = "";
          this.myObj.speciality = "";
          this.myObj.description = "";
          this.myObj.status = "";
          this.myObj.dayOff = "";
          this.myObj.data = "";
          this.file = "";
        });

      console.log(fn);
      this.optionName = "Add";
      this.modals.showModal = false;
    },
    UpdateST() {
      console.log("updating staff:", this.myObj.staffID);
      var url = this.$store.state.domain + "/staff/edit/" + this.myObj.staffID;
      axios
        .put(url, this.myObj)
        .then((response) => {
          if (response.data.status === "error") {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.LoadData();
            // Vue.set(this.tableData, this.eIndex, this.myObj);
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> staff Updated.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        });
      console.log(fn);
      this.optionName = "Add";
      this.modals.showModal = false;
    },
    GetError() {
      return this.fnError;
      return this.flagError;
    },
    AddModal() {
      this.modals.showModal = true;
      this.saving = false;
      this.fnError = "";
      this.lnError = "";
      this.countryError = "";
      this.ratingError = "";
      this.specError = "";
      this.desError = "";
      this.statusError = "";
      this.flagError = "";
      this.myObj.staffID = 0;
      this.myObj.firstName = "";
      this.myObj.lastName = "";
      this.myObj.country = "";
      this.myObj.flag = "";
      this.myObj.profile = "";
      this.myObj.rating = 0;
      this.myObj.speciality = "";
      this.myObj.description = "";
      this.myObj.status = "active";
      this.myObj.dayOff = "";
      this.optionName = "Add";

      this.sign = "fas fa-plus";

      this.cmbStatus.value = {
        name: "Active",
        value: "active",
      };
    },
    editRecord(index, row) {
      this.cmbCountry.value = {};
      this.eIndex = index;
      this.saving = false;
      this.myObj.staffID = row.staffID;
      this.myObj.firstName = row.firstName;
      this.myObj.lastName = row.lastName;
      this.myObj.country = row.country;
      this.myObj.flag = row.flag;
      this.myObj.profile = row.profile;
      this.myObj.rating = row.rating;
      this.myObj.speciality = row.speciality;
      this.myObj.description = row.description;
      this.myObj.status = row.status;
      this.myObj.dayOff = row.dayOff;

      //Populate dropdowns
      this.cmbCountry.data.forEach((elem) => {
        if (elem.value === row.flag) {
          this.cmbCountry.value = elem;
        }
      });

      this.cmbdayOff.data.forEach((elem) => {
        if (elem.value === row.dayOff) {
          this.cmbdayOff.value = elem;
        }
      });

      this.shouldAdd = false;
      this.optionName = "Edit";
      this.modals.showModal = true;
      this.sign = "far fa-edit";
    },
    handleDelete(index, row) {
      var sID = row.staffID;
      console.log("ST ID", sID);
      swal({
        title: "Are you sure?",
        text: "You want to delete staff " + row.firstName + "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          //Remove API
          var url = this.$store.state.domain + "/staff/" + sID;
          console.log("Remove: " + url);
          axios
            .delete(url, qs.stringify(""))
            .then((response) => {
              if (response.data.status === "error") {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: "Request Error! <br />" + response.data.data,
                  type: "danger",
                  icon: "fa fa-ban",
                  timeout: 0,
                });
              } else {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: 'Done! <br />Staff "' + row.firstName + '" removed.',
                  type: "danger",
                  icon: "fa fa-check",
                  timeout: this.$store.state.timeout,
                });

                this.deleteRow(row);
              }
            })
            .catch(function (error) {
              this.$notify({
                verticalAlign: "bottom",
                horizontalAlign: "center",
                message: "Request Error! <br />" + response.data.data,
                type: "danger",
                icon: "fa fa-ban",
                timeout: 0,
              });
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.staffID === row.staffID
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
  computed: {
    getData() {
      return this.$store.state.gridData;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
